<div class="cerrix-hyperlinks-list">
    @if (!!hyperlinks) {
        <div class="hyperlink-list">
            @for (hyperlink of hyperlinks; track hyperlink; let i = $index) {
                <div class="hyperlink-item">
                    <div class="hyperlink-row">
                        <div class="hyperlink-col">
                            <div class="hyperlink-text name">{{ hyperlink.name }}</div>
                            <div class="hyperlink-text description">
                                {{ hyperlink.description }}
                            </div>
                        </div>
                        <div class="hyperlink-col">
                            <div class="hyperlink-text url" [attr.data-uiid]="'hyperlink-' + i + '-url'">
                                <a
                                    [attr.data-uiid]="'hyperlink-' + i + '-url-link'"
                                    (click)="openLink(hyperlink.hyperlink)"
                                    >{{ hyperlink.hyperlink }}</a
                                >
                            </div>
                            <div class="hyperlink-text name">{{ hyperlink.hyperlinkType }}</div>
                        </div>
                        <div class="hyperlink-col actions">
                            @if (canEdit) {
                                <cerrix-icon-button
                                    color="accent-link"
                                    size="small"
                                    [dataUiid]="'hyperlink-' + i + '-edit-button'"
                                    (click)="onEditHyperlink(hyperlink)"
                                >
                                    <mat-icon fontSet="material-symbols-outlined"
                                        >edit_square_outlined</mat-icon
                                    >
                                </cerrix-icon-button>
                            }

                            @if (canDelete) {
                                <cerrix-confirmation-button
                                    btnLabel="Delete?"
                                    [dataUiid]="'hyperlink-' + i + '-delete-button'"
                                    (onConfirmationClick)="onRemoveHyperlink(hyperlink)"
                                >
                                </cerrix-confirmation-button>
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
        @if (hyperlinks.length === 0) {
            <div class="hyperlink-list">
                <div class="hyperlink-item">
                    <div class="hyperlink-row">
                        <div class="hyperlink-col">
                            <div class="hyperlink-text name">No hyperlinks available</div>
                        </div>
                    </div>
                </div>
            </div>
        }
    }

    @if (canAdd) {
        <!-- Add big add button -->
        <div
            [attr.data-uiid]="'hyperlink-add-button-text'"
            class="hyperlink-add-button"
            (click)="onAddHyperlink()"
        >
            <mat-icon class="add-icon" fontSet="material-symbols-outlined">add</mat-icon>
            <span class="add-text">Add Hyperlink</span>
        </div>
    }
</div>
